module.exports = {

   tab :{
      indexw:'主页',
      role:'角色管理',
      user:'用户管理',
      project:'项目管理',
      ipmsSource:'IPMS项目池',
      task:'任务管理',
      subtask:'子任务管理',
      labour:'工时管理',
      labourEngineer:'工程师工时列表',
      labourEnter:'工时录入',
      holiday:'假期日历',
      cronJob:'定时任务',
      labourReport:'工时报表',
      engineerReport:'工程师工时报表',
      group:'组管理',
      manager:'产品经理映射管理',
      majorProject: '重大项目查询',
      project3S2S: '三圈两抓项目',
      projectApplication: '立项申请',
      projectApproval: '立项审批',
      formallyApprovedProject: '正式立项',
      keyFocusProjects: '服务台帐',
      toDo: '待办',
      myFlow: '我的电子流',
      flowQuery: '电子流查询',
      riskManagement: 'Risk Management',
      riskDashboard: 'Risk Dashboard',
      riskAssessmentGuide: 'Risk Assessment Guide',
   },
   //登录页
   innerlogin:'内部登录',
   outterlogin:'外部登录',
   loginnow:'立即登录',
   languages:'语言',
   domain_account:'请输入域账号',
   loginname:'请输入用户账号',
   inputUserName:'请输入用户名',
   enterEmail:'请输入邮箱',
   password:'请输入密码',
   code:'请输入验证码',
   forgetPassword:'忘记密码',
   firstLogin:'初次登录，请先修改密码',
   oldpwd:'原密码',
   newpwd:'新密码',
   verifypwd:'确认密码',
   userAccount:'账号',
   userEmail:'邮箱',userEmail1:'邮箱：',
   updatePassword:'修改密码',
   resetPassword:'重置密码',
   inputErrorCode:'验证码错误',
   inputErrorCode2:'验证码不能为空',
   loginErrorMsg:'账号或者密码错误',
   loginErrorMsg1:'账号和密码不能为空',
   loginErrorMsg2:'账号或者密码错误',
   loginErrorMsg3:'密码修改失败',
   loginErrorMsg4:'密码重置成功，新密码已发送至您的邮箱',
   loginErrorMsg5:'邮件发送失败',
   loginErrorMsg6:'邮箱与账户不匹配，请重新填写',
   loginErrorMsg7:'账号不存在',
   loginErrorMsg8:'两次输入密码不一致',
   loginErrorMsg9:'新密码不能与原密码相同',
   loginErrorMsg10:'冻结用户不能登录',
   loginErrorMsg11:'没有权限登陆，请联系管理员',
   SystemError:'系统错误，请联系管理员',
   setLocation:'设置国家',

   //主页面
   login_out:'退出',
   pwdEror:'密码输入错误',
   pwdSuccess:'密码修改成功',
   TabSelect:'标签选项',
   clearAll:'关闭所有',
   clearOthers:'关闭其他',
   systemtitle:'海外工时管理系统',
   welcomein:'欢迎进入海外工时系统',
   logintime:'登录时间',

   //角色管理
   conditionRoleName:'角色名称：',
   conditionDes:'角色描述：',
   conditionStatus:'状态：',
   addRoleInfo:'新增角色',
   updateRoleInfo:'修改角色',
   operateRole:'权限分配',
   roleName:'角色名称',
   roleDescripe:'角色描述',
   roleState:'状态',
   permissionSettings:'功能分配',
   roleNameNull:'角色名称不能为空',
   roleDesNull:'角色描述不能为空',
   saveSus:'保存成功',
   saveFail:'保存失败',
   modifySus:'修改成功',
   delSus:'删除成功',
   delMsg:'确定删除吗？',
   warnMsg:'警告',
   
   
   //用户管理
   conditionName:'姓名：',
   conditionWorkNumOrZh:'账号：',
   conditionRegionStatus:'状态：',
   conditionType:'用户类型：',
   yuNo:'账号',
   name:'姓名',
   createTime:'创建时间',
   addUserInfo:'新增用户',
   updateUserInfo:'修改用户',
   innerUser:'内部用户',
   supplierUser:'服务商账户',
   outterUser:'外部用户',
   conditionWorkNum:'域账号：',
   conditionMailbox:'邮箱：',
   conditionSupplierName:'服务商姓名：',
   userMsg:'该账号已存在，不能添加',
   userMsg1:'请输入正确格式的邮箱地址',
   emailNull:'邮箱不能为空',
   resetMsg:'确定重置密码吗？',
   selectMsg:'请选择服务商',
   resetMsg1:'内部用户不能重置密码！',
   resetMsg2:'请先勾选用户！',
   resetMsg3:'请勾选一个用户！',
   updateMsg:'内部用户不能修改信息！',
   freezeMsg:'账号冻结成功',
   unFreezeMsg:'账号解冻成功',
   userEmpower:'用户赋权',
   userRoleEmpower:'角色权限',
   userDataEmpower:'数据权限',
   permissionDesc:'权限描述',
   dataMsg:'请先勾选数据！',
   empowerMsg:'用户权限设置成功',
   hasRole:'角色',hasRole1:'角色：',
   userLocation:'国家',
   roleAssigned:'角色',
   additionalRecording:'补录',


   //table 中按钮查询选项
   Total:'共',
   items:'条',
   operate:'操作',
   search:'查询',
   add:'新增',
   update:'修改',
   approve:'审批',
   delete:'删除',
   export:'导出',
   trendExport:'月度趋势导出',
   import:'导入',
   refresh:'刷新',
   cancle:'取消',
   confrim:'确定',
   return:'返回',
   revoke:'撤销',
   enter:'请输入内容',
   number:'请输入数字',
   empower:'赋权',
   freeze:'冻结',
   unFreeze:'解冻',
   clone:'克隆',
   selectdate:'请选择日期',
   selectmonth:'请选择月份',
   save:'保存',
   save_continue:'保存，继续添加',
   reason:'请输入原因',
   closed:'关闭',
   sequnce:'序号',
   Yes:'是',
   No:'否',
   advancedFilter:'高级筛选',
   remark:'备注',
   select:'请选择',
   upload:'上传',
   reportAttachment:'附件',
   execute:'执行',
   download:'下载',
   batchEdit:'批量修改',
   batchFrozen:'冻结',
   batchUnfrozen:'解冻',
   beginTime:'开始时间',
   endTime:'结束时间',
   beginMonth:'开始月份',
   endMonth:'结束月份',
   choose:'选择',

   //项目信息
   addToProject:'添加到项目',
   projectPool:'IPMS 项目源',
   projectName:'项目名称',
   projectNumber:'项目编码',
   projectType:'项目类型',
   projectManager:'项目经理',
   deputyProjectManager:'代理项目经理',
   projectStartDate:'项目开始日期',
   projectEndDate:'项目结束日期',
   projectInfo:'项目信息',
   customerInfo:'客户信息',
   contractInfo:'合同信息',
   projectStatus:'项目状态',
   projectSource:'项目来源',
   businessCategory:'业务类别',
   department:'所属部门',
   industry:'所属行业',
   subcontract:'是否转包',
   ouEntity:'业务主体',
   deliveryType:'项目交付方式',
   projectLevel:'项目级别',
   projectEstimatedEndDate:'项目预计完成日期',
   projectActualEndDate:'项目实际完成日期',
   projectCloseDate:'项目关闭时间',
   beneficialDept:'受益部门',
   finalBeneficialDept:'最终受益部门',
   salesMan:'销售人员',
   salesRegion:'销售区域',
   presaleKeyProject:'售前重大项目',
   postsaleKeyProject:'售后重大项目',
   country:'国家',
   beltAndRoad:'一带一路',
   subcontractor:'转包服务商',
   businessType:'销售业务类型',
   freezingReason:'冻结原因',
   unFreezingReason:'解冻原因',
   taskNum:'任务数量',
   subtaskNum:'子任务数量',
   labourSum:'交付工时',
   upstreamSystemId:'上游系统编码',
   ipmsProjectCode:'IPMS项目编码',
   addTask:'添加任务',
   testLeader:'测试负责人',
   testNature:'测试类型',

   //新增展示
   projectStatus1:'项目状态：',
   projectName1:'项目名称：',
   projectNumber1:'项目编码：',
   projectType1:'项目类型：',
   projectManager1:'项目经理：',
   deputyProjectManager1:'代理项目经理：',
   projectStartDate1:'项目开始日期：',
   projectEndDate1:'项目结束日期：',
   businessCategory1:'业务类别：',
   department1:'所属部门：',
   industry1:'所属行业：',
   subcontract1:'是否转包：',
   ouEntity1:'业务主体：',
   deliveryType1:'项目交付方式：',
   projectLevel1:'项目级别：',
   projectEstimatedEndDate1:'项目预计完成日期：',
   projectActualEndDate1:'项目实际完成日期：',
   projectCloseDate1:'项目关闭时间：',
   beneficialDept1:'受益部门：',
   finalBeneficialDept1:'最终受益部门：',
   remark1:'备注：',
   salesMan1:'销售人员：',
   salesRegion1:'销售区域：',
   presaleKeyProject1:'售前重大项目：',
   postsaleKeyProject1:'售后重大项目：',
   country1:'国家：',
   beltAndRoad1:'一带一路：',
   subcontractor1:'转包服务商：', 
   businessType1:'销售业务类型：',
   upstreamSystemId1:'上游系统编码：',
   projectID:'项目ID',
   ipmsProjectCode1:'IPMS项目编码：',
   addTask1:'添加任务：',
   testLeader1:'测试负责人：',
   testNature1:'测试类型：',

   //客户信息
   //列表展示
   customerName:'客户名称',
   csiAccountCode:'CSI客户编码',
   customerIndustry:'客户一级行业',
   subIndustry:'客户二级行业',
   customerType:'客户类型',
   customerContact:'客户联系人',
   customerMobile:'客户联系电话',
   customerAddress:'客户地址',
   //新增修改展示
   customerName1:'客户名称：',
   csiAccountCode1:'CSI客户编码：',
   customerIndustry1:'客户一级行业：',
   subIndustry1:'客户二级行业：',
   customerType1:'客户类型：',
   customerContact1:'客户联系人：',
   customerMobile1:'客户联系电话：',
   customerAddress1:'客户地址：',

   //合同信息
   //列表展示
   serviceContractNo:'服务合同号',
   productContractNo:'产品合同号',
   purchaseOrderNo:'一级订单号',
   salesOrderNo:'二级订单号',
   reseller:'出货代理商',
   distributor:'销售代理商',
   serviceSalesModule:'销售模式',
   serviceSalesType:'销售方式',
   firstShipmentDate:'首次发货日期',
   estimatedServiceStartDate:'预计服务启动时间',
   serviceDuration:'服务年限',
   maintenanceStartCondition:'维保开始条件',
   maintenanceStartDate:'维保开始时间',
   maintenanceEndDate:'维保结束时间',
   maintenanceContent:'维保说明',
   amountExdudingTax:'未税订单额',
   amountWithTax:'含税订单额',
   listPrice:'目录价',
   attachServiceId:'随项目ID',
   ibServiceId:'单独销售ID',
   orderStatus:'订单状态',
   contactVersionNo:'合同版本号',
   bomCode:'BOM编码',
   bomName:'BOM名称',
   currency:'币种：',
   //新增修改展示
   serviceContractNo1:'服务合同号：',
   productContractNo1:'产品合同号：',
   purchaseOrderNo1:'一级订单号：',
   salesOrderNo1:'二级订单号：',
   reseller1:'出货代理商：',
   distributor1:'销售代理商：',
   serviceSalesModule1:'销售模式：',
   serviceSalesType1:'销售方式：',
   firstShipmentDate1:'首次发货日期：',
   estimatedServiceStartDate1:'预计服务启动时间：',
   serviceDuration1:'服务年限：',
   maintenanceStartCondition1:'维保开始条件：',
   maintenanceStartDate1:'维保开始时间：',
   maintenanceEndDate1:'维保结束时间：',
   maintenanceContent1:'维保说明：',
   amountExdudingTax1:'未税订单额：',
   amountWithTax1:'含税订单额：',
   listPrice1:'目录价：',
   attachServiceId1:'随项目ID：',
   ibServiceId1:'单独销售ID：',
   orderStatus1:'订单状态：',
   contactVersionNo1:'合同版本号：',
   bomCode1:'BOM编码：',
   bomName1:'BOM名称：',
   currency1:'币种：',

   //任务信息
   //列表展示
   taskInfo:'任务信息',
   taskName:'任务名称',
   taskNumber:'任务编号',
   taskOwner:'任务负责人',
   taskStatus:'任务状态',
   taskType:'任务类型',
   serviceContent:'服务内容',
   serviceBom:'服务BOM',
   bomDescription:'BOM描述',
   financialAttributes:'财务属性',
   taskSubcontract:'是否转包',
   taskSubcontractor:'转包服务商',
   revenueConfirmationMethod:'收入确认方式',
   hardwareProductLine:'硬件产品线',
   serviceProductLine:'服务产品线',
   productCode:'产品编号',
   taskStartDate:'开始日期',
   taskEndDate:'结束日期',
   taskCloseDate:'关闭日期',
   deliveryArea:'交付区域',
   deliveryLabourHour:'交付工时',
   revenueConfirmationAmount:'收入确认额',
   revenueConfirmationStatus:'收入确认状态',
   taskAmountWithTax:'含税订单额',
   deliveryFinishDate:'交付完成日期',
   subcontractNo:'转包合同号',
   serviceQuantity:'服务数量',
   taskCompletion:'任务完成情况',
   taskReport:'完工凭证',
   addSubtask:'添加子任务',
   planLabourHour:'计划工时',
   //编辑展示
   taskName1:'任务名称：',
   taskNumber1:'任务编号：',
   taskOwner1:'任务负责人：',
   taskStatus1:'任务状态：',
   taskType1:'任务类型：',
   serviceContent1:'服务内容：',
   serviceBom1:'服务BOM：',
   bomDescription1:'BOM描述：',
   financialAttributes1:'财务属性：',
   taskSubcontract1:'是否转包：',
   taskSubcontractor1:'转包服务商：',
   revenueConfirmationMethod1:'收入确认方式：',
   hardwareProductLine1:'硬件产品线：',
   serviceProductLine1:'服务产品线：',
   productCode1:'产品编号：',
   taskStartDate1:'开始日期：',
   taskEndDate1:'结束日期：',
   taskCloseDate1:'关闭日期：',
   deliveryArea1:'交付区域：',
   deliveryLabourHour1:'交付工时：',
   revenueConfirmationAmount1:'收入确认额：',
   revenueConfirmationStatus1:'收入确认状态：',
   taskAmountWithTax1:'含税订单额：',
   deliveryFinishDate1:'交付完成日期：',
   subcontractNo1:'转包合同号：',
   serviceQuantity1:'服务数量：',
   taskCompletion1:'任务完成情况：',
   taskReport1:'完工凭证：',
   addSubtask1:'添加子任务：',
   planLabourHour1:'计划工时：',


   //子任务信息
   //列表展示
   subtaskInfo:'子任务信息',
   subtaskName:'子任务名称',
   subtaskNumber:'子任务编号',
   plannedLabourHour:'下发工时',
   totalPlannedHour:'总下发工时',
   deliveredLabourHour:'交付工时',
   subtaskStatus:'子任务状态',
   subtaskType:'子任务类型',
   actualDeliveryEngineer:'实际交付人员',
   deliveryEngineerCity:'交付人员所在城市',
   deliveryAddress:'交付地点',
   subtaskEstimatedStartDate:'预计开始日期',
   subtaskEstimatedEndDate:'预计结束日期',
   serviceStartDate:'服务开始日期',
   serviceEndDate:'服务结束日期',
   subtaskCloseDate:'关闭日期',
   plannedDate:'下发日期',
   deliveryFinishedDate:'交付完成日期',
   isStationin:'是否驻场',
   subtaskDeliveryType:'子任务交付类型',
   subtaskCompletion:'子任务完成情况',
   addLabour:'添加工时',
   subtaskReport:'现场服务报告',
   selectSubtask:'选择子任务',
   subtaskRemark:'子任务描述',
   //编辑展示
   subtaskName1:'子任务名称：',
   subtaskNumber1:'子任务编号：',
   plannedLabourHour1:'下发工时：',
   totalPlannedHour1:'总下发工时：',
   deliveredLabourHour1:'交付工时：',deliveredLabourHour2:'休假时长：',
   subtaskStatus1:'子任务状态：',
   subtaskType1:'子任务类型：',
   actualDeliveryEngineer1:'实际交付人员：',actualDeliveryEngineer2:'交付人员：',
   deliveryEngineerCity1:'交付人员所在城市：',
   deliveryAddress1:'交付地点：',
   subtaskEstimatedStartDate1:'预计开始日期：',
   subtaskEstimatedEndDate1:'预计结束日期：',
   serviceStartDate1:'服务开始日期：',
   serviceEndDate1:'服务结束日期：',
   subtaskCloseDate1:'关闭日期：',
   plannedDate1:'下发日期：',
   deliveryFinishedDate1:'交付完成日期：',
   isStationin1:'是否驻场：',
   subtaskDeliveryType1:'子任务交付类型：',subtaskDeliveryType2:'交付类型：',
   subtaskCompletion1:'子任务完成情况：',
   addLabour1:'添加工时：',
   subtaskReport1:'现场服务报告：',
   subtaskRemark1:'子任务描述：',


   //工时信息
   //列表展示
   labourInfo:'工时信息',
   labourHourId:'工时编号',
   workDate:'工作日期',
   workContent:'工作内容',
   workDescribe:'描述',
   workHours:'工作时长',
   travelHours:'在途工时',
   refreshDate:'刷新日期',
   ocmsCaseNumber:'OCMS问题单编号',
   accountName:'客户名称',
   labourStatus:'工时状态',
   hourEntry:'工时条数',
   workSummary:'工时汇总',
   travelSummary:'在途工时汇总',
   totalHours:'总工时',
   ProductLine:'产品线',
   //编辑展示
   workDate1:'工作日期：',
   workContent1:'工作内容：',
   workDescribe1:'描述：',
   workHours1:'工作时长：',
   travelHours1:'在途工时：',
   refreshDate1:'刷新日期：',
   ocmsCaseNumber1:'OCMS问题单编号：',
   accountName1:'客户名称：',
   labourStatus1:'工时状态：',
   workMonth1:'工作月份：',
   representativeSupport:'代表处支持',
   //假期日历
   holidayDate:'假期日历',
   isHoliday:'是否假期',


   //附件
   fileSourceName:'名称',
   fileName:'文件名称',
   fileSource:'文件来源',
   createUser:'创建用户',

   //定时job
   jobValue:'定时任务名称',
   isvalid:'是否执行',
   runtime:'执行时间',
   nextRuntime:'下次执行时间',
   cycelTime:'执行周期',
   jobTime:'定时CRON',
   jobDesc:'定时任务描述',
   //编辑
   jobValue1:'定时任务名称：',
   isvalid1:'是否执行：',
   runtime1:'执行时间：',
   nextRuntime1:'下次执行时间：',
   cycelTime1:'执行周期：',
   jobTime1:'定时CRON：',
   jobDesc1:'定时任务描述：',

   //报表
   reportMonth:'工时月份：',
   trendMonth:'对比月份：',
   empCode:'工号',
   holidayDays:'公共休假天数',
   workDays:'应填写工时天数',
   standardHours:'每日标准工作小时数',
   saturatedHours:'饱和工时数',
   saturationPercent:'饱和度百分比',

   marketFee:'Market support 工时数',
   marketPercent:'Market support 工时占比',
   contractFee:'Contract delivery 工时数',
   contractPercent:'Contract delivery 工时占比',
   warrantyFee:'Warranty 工时数',
   warrantyPercent:'Warranty 工时占比',
   serviceFee:'Service support 工时数',
   servicePercent:'Service support 工时占比',
   generalFee:'General work 工时数',
   generalPercent:'General work 工时占比',

   //产品清单
   inventory:'产品清单',
   productBom:'设备Bom',
   productName:'设备名称',
   productDesc:'设备描述',
   
   //个人信息
   userId:'用户ID',
   employeeId:'人员ID',
   employeeName:'人员姓名',
   laborRate:'人工费率',
   labourRateType:'人工费率类型',
   Currency:'通货',
   createBy:'创建者',
   updateBy:'更新者',
   createDt:'创建日期',
   updateDt:'更新日期',
   dataStatus:'数据状态',
   islhToken:'islh Token',
}


// WEBPACK FOOTER //
// ./src/assets/i18n/langs/zh.js